import { YN_TYPE } from 'types/enumType';

export class CustomerSearchRequest {
  activate: YN_TYPE | null;

  searchKey: string;

  page: number;

  count: number;

  customerId?: string;

  constructor(page: number, count: number, ) {
    this.activate = null;

    this.searchKey = '';
    this.page = page;
    this.count = count;
    this.customerId = '';
  }
}
